import { resources as maintenanceResources } from '@atlassian/eoc-maintenance/resources';
import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { opsSettingsLayout } from '@atlassian/jira-ops-settings-layout/src/index.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { eocGlobalMaintenanceRoute } from '@atlassian/jira-router-routes-eoc-maintenance-routes/src/eocGlobalMaintenanceRoute.tsx';
import AsyncSidebarGlobalSettingsProducts from '@atlassian/jira-navigation-apps-sidebar-global-settings-products/src/async.tsx';
import {
	AsyncHorizontalOperationsConfigurationNav,
	LazyHorizontalOperationsConfigurationNav,
} from '@atlassian/jira-operations-configurations-horizontal-nav/src/async.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { LazySidebarContent } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-settings-global-operations/src/ui/index.tsx';
import { LazyMaintenance, MaintenanceComponent } from './ui/MaintenanceComponent.tsx';

const getNavigationSpecifications = () => {
	return fg('operations_nav4_remaining_items')
		? {
				sidebarId: SIDEBAR_ID.OPERATIONS_GENERAL_CONFIGURATION,
			}
		: {
				sidebar: AsyncSidebarGlobalSettingsProducts,
				horizontal: AsyncHorizontalOperationsConfigurationNav,
			};
};

export const eocGlobalMaintenanceRouteEntry = createEntry(eocGlobalMaintenanceRoute, () => ({
	group: 'eoc',
	component: MaintenanceComponent,
	layout: opsSettingsLayout,

	resources: [
		...getNavigationResources(),
		...getNavigationSidebarProductsSettingResource(),
		...maintenanceResources(),
	],

	navigation: {
		menuId: MENU_ID.SETTINGS,
		...getNavigationSpecifications(),
	},

	forPaint: fg('operations_nav4_remaining_items')
		? [LazySidebarContent, LazyAtlassianNavigation, LazyMaintenance]
		: [LazyHorizontalOperationsConfigurationNav, LazyAtlassianNavigation, LazyMaintenance],

	bifrost: {
		bifrostGroup: 'shell-only',

		bundling: {
			packageName:
				'@atlassian/jira-router-routes-eoc-maintenance-entries/src/eocGlobalMaintenanceRouteEntry.tsx',
			whichExportToUse: 'eocGlobalMaintenanceRouteEntry',
		},

		enabled: true,
	},
}));
